import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import { isLoggedIn } from "../helpers/userSession"; 
import { CASSINO_ENABLED, ESCALACAO_ENABLED } from "../helpers/features";

const cassinoGuard = (to, from, next) => CASSINO_ENABLED ? next() : next({ name: 'cassino' })

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/convite/:token',
    name: 'invite',
    component: () => import('../views/InviteView.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/BetsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/bets',
    name: 'bets',
    component: () => import('../views/BetsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/bets/:id',
    name: 'bet-view',
    component: () => import('../views/BetView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/my-bets',
    name: 'my-bets',
    component: () => import('../views/MyBetsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/bagres',
    name: 'bagres',
    component: () => import('../views/BagresView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/cassino',
    name: 'cassino',
    component: () => import('../views/Cassino.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/slot-machine',
    name: 'slot-machine',
    component: () => import('../views/SlotMachine.vue'),
    beforeEnter: cassinoGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/coin-flip',
    name: 'coin-flip',
    component: () => import('../views/CoinFlip.vue'),
    beforeEnter: cassinoGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/escalacao',
    name: 'escalacao',
    component: () => import('../views/LineupView.vue'),
    beforeEnter: (to, from, next) => ESCALACAO_ENABLED ? next() : next({ name: 'bets' }),
    meta: { requiresAuth: true }
  },
  {
    path: '/finances',
    name: 'finances',
    component: () => import('../views/FinancesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/MyProfile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdmView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: (to, from, next) => {
      localStorage.removeItem('accesToken');
      next({ name: 'login' });
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const isAuthenticated = isLoggedIn();
    if (!isAuthenticated) {
      next({ 'name': 'login' }) 
    } else {
      next()
    }
  } else {
    next()
  }
})

// depois de um deploy, uma aba antiga pede telas (chunks) que não existem mais: recarrega uma vez
const CHUNK_RELOAD_KEY = 'chunk-reload-at'
router.onError((error, to) => {
  if (!/Loading (CSS )?chunk|Failed to fetch dynamically imported module/i.test(error?.message || '')) return
  let last = 0
  try { last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0) } catch { /* sem storage */ }
  if (Date.now() - last < 10000) return  // já tentou agora há pouco: não entra em loop
  try { sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now())) } catch { /* sem storage */ }
  window.location.assign(to.fullPath)
})

export default router